import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import * as RadioButton from 'components/RadioButton';

const RadioButtonComponent = props => (
  <Field
    type="radio"
    name={props.name}
    value={props.value}
    labelClassName={props.labelClassName}
    component={RadioButton.ReduxFormWrapper}
    onChange={props.onChange}
  >
    {props.children}
  </Field>
);

RadioButtonComponent.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  labelClassName: PropTypes.string,
  onChange: PropTypes.func
};

export const RadioButtonsGroup = ({
  labelGroupRadioButton,
  onChange,
  buttons
}) => (
  <div className="mb-20">
    <p className="main-dropdown__label">{labelGroupRadioButton}</p>
    {buttons.map(({ value, name, labelClassName, isDisabled, label }) => (
      <Field
        type="radio"
        key={value}
        value={value}
        name={name}
        labelClassName={labelClassName}
        component={RadioButton.ReduxFormWrapper}
        onChange={onChange}
        disabled={isDisabled}
      >
        {label}
      </Field>
    ))}
  </div>
);

RadioButtonsGroup.propTypes = {
  labelGroupRadioButton: PropTypes.string.isRequired,
  buttons: PropTypes.array.isRequired,
  onChange: PropTypes.func
};

export default RadioButtonComponent;
